import { Link, useSearchParams } from 'react-router-dom';

const navigation = {
  main: [
    { name: '마이페이지', href: '/gift-store/orders', mobile: true },
    {
      name: '이용약관',
      href: '/gift-store/terms',
      mobile: false,
      title: 'use',
    },
    {
      name: '개인정보처리방침',
      href: '/gift-store/terms',
      mobile: false,
      title: 'privacy',
    },
    {
      name: '교환 및 환불 규정',
      href: '/gift-store/terms',
      mobile: false,
      title: 'refund',
    },
  ],
};

export default function GiftStoreFooter() {
  const [searchParams] = useSearchParams();
  const bugoId = searchParams.get('bugoId');

  return (
    <footer className="hidden border-t bg-gray-50 sm:block">
      <div className="mx-auto max-w-7xl overflow-hidden px-4 pb-8 pt-4 sm:px-6 lg:px-8">
        <nav
          className="-mx-5 -my-2 mt-2 flex flex-wrap justify-center"
          aria-label="Footer"
        >
          {navigation.main.map((item) => (
            <div
              key={item.name}
              className={`${item.mobile ? 'block' : 'hidden sm:block'} px-2 py-2 sm:px-5`}
            >
              <Link
                to={
                  item.href +
                  (item.title ? `?title=${item.title}` : '') +
                  (bugoId ? `${item.title ? '&' : '?'}bugoId=${bugoId}` : '')
                }
                className={`${
                  item.mobile ? 'block' : 'hidden sm:block'
                } text-sm text-gray-500 hover:text-gray-900`}
              >
                {item.name}
              </Link>
            </div>
          ))}
        </nav>

        <div className="hidden sm:block">
          <p className="mt-4 text-center text-xs text-gray-400">
            사업자 등록번호 : 363-86-02183 &nbsp;| &nbsp;대표 : 김기훈, 정호산
            <br />
            서울특별시 금천구 가산디지털2로 101, 한라원앤원타워 제A동 7층 703~704호
            <br />
            CS : 1877-1954&nbsp; |&nbsp; 메일 : smartnanumi@kakao.com
            <br />
            통신판매업신고 : 제 2023-서울금천-0445호
          </p>
        </div>

        <p className="mt-4 text-center text-sm text-gray-400">
          &copy; 2021 GAON prime, Corp. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
